<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        :useRowIndex="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col cols="6">
                    <BaseEditPageTextField 
                        :context="context"
                        :field="sheetType === 'film/tv' ? 'WorkSheetSeconds' : 'WorkSetlistSeconds'"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SECONDS')"
                        :withMargin="false"
                        :alvqa="alvqa + '-dropdown-work-' + sheetType === 'film/tv' ? 'sheet' : 'setlist' + '-seconds'"
                        :additionalFunction="convertTimeToSeconds"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        :field="sheetType === 'film/tv' ? 'WorkAvType' : 'WorkSetlistType'"
                        :items="sheetType === 'film/tv' ? avTypeItems : setlistTypes" 
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_TYPE')"
                        :selection="true"
                        :withMargin="false"
                        :alvqa="alvqa + '-dropdown-work-' + sheetType === 'film/tv' ? 'av' : 'setlist' + '-type'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        :field="sheetType === 'film/tv' ? 'WorkCharacteristicType' : 'BigRight'"
                        :items="sheetType === 'film/tv' ? workCharacteristicTypeItems : bigRightItems" 
                        :label="$t(sheetType === 'film/tv' ? 'lang_PUBLISHING_SHEETS_CAPTION_CHARACTERISTIC' : 'lang_GENERAL_CAPTION_TYPE_OF_RIGHTS_BIG_RIGHT')"
                        :selection="true"
                        :withMargin="false"
                        :alvqa="alvqa + '-dropdown-work-' + sheetType === 'film/tv' ? 'characteristic-type' : 'big-right'"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import 
    { 
        DropdownPublishingSheetsWorkAvType,
        DropdownPublishingSheetsWorkCharacteristicType,
        DropdownPublishingSheetsWorkSetlistType,
        DropdownGenericYesNo
    } 
from '@/assets/dropdowns/alvDropdowns.js'

import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageTextField    from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown     from '@/components/_editForm/BaseEditPageDropdown'

export default {
    name: "WorksEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageTextField,
        BaseEditPageDropdown
    },
    data() {
        return {
            context: "SheetsWorks",
            alvqa: "publishing-sheets-edit-form-works-panel-editing-dialog"
        }
    },
    computed: {
        avTypeItems() { return DropdownPublishingSheetsWorkAvType },
        workCharacteristicTypeItems() { return DropdownPublishingSheetsWorkCharacteristicType },
        setlistTypes() { return DropdownPublishingSheetsWorkSetlistType },
        bigRightItems() { return DropdownGenericYesNo },
        sheetType() { return this.$store.getters.getSheetDetailsType },
        secondsField() { return this.sheetType === 'film/tv' ? 'WorkSheetSeconds' : 'WorkSetlistSeconds' }
    },
    methods: {
        convertTimeToSeconds() {
            let value = this.$store.getters['get' + this.context + 'Details' + this.secondsField]
            if (value && typeof value === 'string' && value.includes(':')) {
                const parts = value.split(':')
                const lastPart = parts[parts.length - 1]
                if (lastPart.length !== 2) return
                const allPartsValid = parts.every(p => p !== '' && !isNaN(parseInt(p, 10)))
                if (!allPartsValid) return
                const numParts = parts.map(p => parseInt(p, 10))
                let seconds = 0
                if (numParts.length === 2) {
                    seconds = numParts[0] * 60 + numParts[1]
                } else if (numParts.length === 3) {
                    seconds = numParts[0] * 3600 + numParts[1] * 60 + numParts[2]
                }
                if (seconds > 0) {
                    this.$store.commit('set' + this.context + 'Details' + this.secondsField, seconds)
                }
            }
        }
    }
}
</script>